import { render, staticRenderFns } from "./StudioOnboardingModal.vue?vue&type=template&id=3603aa99&scoped=true&"
import script from "./StudioOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./StudioOnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./StudioOnboardingModal.vue?vue&type=style&index=0&id=3603aa99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603aa99",
  null
  
)

export default component.exports